export default {
    language: 'English',
    search: {
        name: 'Product Search',
        by: 'Keywords(Model)',
        placeholder: 'Please input model.'
    },
    topNavigation: [
        {name: 'News', active: '', path: '/news'},
        {
            name: 'Contact Us', active: '', path: '/contact', way: [
                {name: 'E-MAIL', active: 'margin-top: 20px;font-size: 13px', icon: 'el-icon-message', value: '1074404871@qq.com'},
                {name: 'PHONE', active: 'margin-top: 20px;font-size: 13px', icon: 'el-icon-phone-outline', value: '18420198061'},
                {name: 'FAX', active: 'margin-top: 20px;font-size: 13px', icon: 'el-icon-receiving', value: 'xx-xxxxxxxx'},
                {
                    name: 'ADDRESS',
                    active: 'font-size: 12px;padding: 10px 10px',
                    icon: 'el-icon-location-outline',
                    value: 'NO.4-1,XIABEI VILLAGE,LONGTIAN COMMUNITY,LONGTIAN STREET,PINGSHAN DISTRICT,SHENZHEN CITY'
                }
            ]
        },
        {name: 'Site Map', active: '', path: '/site_map'}
    ],
    headNavigation: [
        {name: 'Products', active: '', path: '/products'},
        {name: 'Technology', active: '', path: '/technology'},
        {name: 'Company', active: '', path: '/company'}
        // {name:'IR Information',active: '',path: '/ir'}
    ],
    botNavigation: [
        {
            title: 'Products', path: '/products', element: [
                {name: 'Product Search', active: '', path: '/products/search'},
                {name: 'Product Information', active: '', path: '/'}
            ]
        },
        {
            title: 'Technology', path: '/technology', element: [
                {name: 'Cutting Data', active: '', path: '/'},
                {name: 'Technical Data', active: '', path: '/'}
            ]
        },
        {
            title: 'Company', path: '/company', element: [
                {name: 'Outline', active: '', path: '/company/outline'},
                {name: 'Certificate',active: '', path: '/company/certificate'},
                {name: 'History', active: '', path: '/company/history'},
                {name: 'Environmental Policy', active: '', path: '/company/environment'}
            ]
        },
        // {title:'IR Information',path: '/ir',element:[
        //         {name:'Research Report',active:'',path: '/'},
        //         {name:'Financial Report',active:'',path: '/'},
        //         {name:'Business Report',active:'',path: '/'}
        //     ]},
        // {title:'News & Events',path: '/',element:[
        //         {name:'Products',active:'',path: '/'},
        //         {name:'Events',active:'',path: '/'},
        //         {name:'Company',active:'',path: '/'}
        //     ]},
        {
            title: 'Others', element: [
                {name: 'News', active: '', path: '/news'},
                {name: 'Contact Us', active: '', path: '/contact'},
                {name: 'Sitemap', active: '', path: '/site_map'}
            ]
        },
    ],
    languages: [
        {code: 'zhCN', name: 'Chinese'},
        {code: 'zhTW', name: 'Chinese Traditional'}
    ],
    something: [
        {title: 'PRODUCTS', details: 'Introducing our products information', active: '', path: '/products'},
        {
            title: 'TECHNOLOGY',
            details: 'Introducing the processing cases & technical data',
            active: '',
            path: '/technology'
        },
        {title: 'COMPANY', details: 'About us,access map & environmental policy', active: '', path: '/company'}
        // {title:'IR Information',details:'Investor Information & Various financial statements',active: 'pointer-events: none;',path: '/ir'}
    ],
    routeMap: [
        {name: 'HOME', path: '/'},
        {
            name: 'Products', path: '/products', son: [
                {name: 'Product Search', path: '/products/search'},
                {name: 'Product Information', path: '/'}
            ]
        },
        {
            name: 'Technology', path: '/technology', son: [
                {name: 'Cutting Data', path: '/technology/cutting_data'},
                {name: 'Technical Data', path: '/technology/technical_data'}
            ]
        },
        {
            name: 'Company', path: '/company', son: [
                {name: 'Outline', path: '/company/outline'},
                {name: 'Certificate', path: '/company/certificate'},
                {name: 'History', path: '/company/history'},
                {name: 'Environmental Policy', path: '/company/environment'},
            ]
        },
        {
            name: 'Others', son: [
                {name: 'News', path: '/news'},
                {name: 'Contact', path: '/contact'},
                {name: 'Site Map', path: '/site_map'},
            ]
        }
    ],
    company: [
        {
            name: 'Outline', active: '', path: '/company/outline', imageUrl: '../../../public/static/outline.png',
            table: [
                {title: 'Corporate', information: 'SHENZHEN CHEUK HEI ER TECHNOLOGY CO.,LTD.'},
                {title: 'President', information: 'Yiming Yeung'},
                {
                    title: 'Head Office',
                    information: '6F., Sumitomo Fudosan Oimachi Ekimae Bldg., 1-28-1 Oi, Shinagawa-ku, Tokyo 140-0014'
                },
                {title: 'Established', information: 'December 1999'},
                {title: 'Capital', information: '455,330,523 yen'},
                {title: 'Business Profile', information: 'Manufacture and Sale of cutting tools'},
                {title: 'Products', information: 'Solid carbide end mills for Hi-Tech industries'},
                {title: 'Bankers', information: 'MUFG Bank, Ltd. Mizuho Bank, Ltd.'}
            ]
        },
        {
            name:'Certificate',active: '',path: '/company/certificate',imageUrl: '../../../public/static/certificate.png'
        }
        ,
        {
            name: 'History', active: '', path: '/company/history', imageUrl: '../../../public/static/history.png',
            table: [
                {year: 1954, event: 'Started business as a machine tool manufacturer.'},
                {year: 1961, event: 'Established Nisshin Kogu Seisakusho L.C.'},
                {year: 1972, event: 'Introduced “Power End Mills” which contributed to metal industry.'},
                {year: 1977, event: 'Started Exports.'},
                {year: 1979, event: 'Reorganized to Nisshin Kogu Seisakusho Co., Ltd.'},
                {year: 1980, event: 'Full-entry to die and mold industry with solid carbide end mills.'},
                {year: 1989, event: '3 production base systems were Established after established Fujisawa Factory.'},
                {year: 1990, event: 'Established a sales subsidiary, G-Tech Co., Ltd.'},
            ]
        },
        {
            name: 'Environmental Policy',
            active: '',
            path: '/company/environment',
            imageUrl: '../../../public/static/environment.png',
            intro: 'CHEIER TOOL strives to develop and ' +
                'manufacture high value-added and high quality ' +
                'products for effective utilization of natural resources. ' +
                'In order to contribute to the social development, ' +
                'we keep supplying valuable products and technical services.',
            content: [
                {content: 'We promote consecutive improvement in the Environment Management System.'},
                {content: 'We strive to prevent environmental pollution such as ambient noise, shaking and air & water pollution due to emission gas & drainage by our operational activities.'},
                {content: 'We strive for environmental protection compliance with environment-related law, regulation & agreement.'},
                {content: 'We strive to reduce waste and to save natural resources & energy in manufacturing and office activities.'},
                {content: 'To achieve certainly the Environment Management System, we promote activities based on an implementation plan by setting up an environmental object and goal.'},
                {content: 'The Environment Management System shall be written and made known by the management to every employee, and disclose to the public respond to its request.'},
            ],
            author: 'Yiming Yeung,President',
            date: 'November 12,2023'
        }
    ],
    series: [
        {name: 'CuttingTool'},
        {name: 'Diamond'},
        {name: 'Optical'},
        {name: 'Superhard Material'}
    ]
}